<template>
  <div class="mt-8">
    <v-navigation-drawer permanent expand-on-hover app>
      <v-divider></v-divider>
      <v-list nav dense v-for="(item, i) in items" :key="i">
        <v-list-item
          :key="item.title"
          class="list-item-shadow"
          link
          :to="item.to"
          v-if="!item.nested"
          @click="checkMenu(item)"
        >
          <v-list-item-icon class="mr-3">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-else no-action :prepend-icon="item.icon">
          <template #activator>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>

          <v-list-item v-for="(item2, index) in item.subitems" :key="index" link :to="item2.to">
            <v-list-item-icon>
              <v-icon class="ml-n10">{{ item2.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n10">{{ item2.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  data() {
    return {
      selectedItem: "",
      items: [
        {
          title: "รายงานภาพรวม",
          icon: "mdi-view-dashboard",
          to: "/index/dashboard",
          nested: false,
        },
        {
          title: "รายงานรายสัปดาห์",
          icon: "mdi-chart-bar",
          to: "/index/week-report",
          nested: false,
        },
        {
          title: "รายชื่อผู้ลงทะเบียน",
          icon: "mdi-file-document-multiple-outline",
          to: "/index/register-summary",
          nested: false,
        },
        {
          title: "สรุปผลกิจกรรม",
          icon: "mdi-chart-box-outline",
          to: "/index/activity-summary",
          nested: false,
        },
        {
          title: "สรุปแบบสอบถามสุขภาพ",
          icon: "mdi-chart-box-outline",
          to: "/index/Count-Health",
          nested: false,
        },
        {
          title: "จำนวนการเข้าร่วมกิจกรรม",
          icon: "mdi-clipboard-list-outline",
          to: "/index/Count-Activity",
          nested: false,
        },

        // {
        //   title: "จัดการบทความ",
        //   icon: "mdi-file-document-edit-outline",
        //   to: "/index/list-articles",
        // },
        {
          title: "ตั้งค่า",
          icon: "mdi-cog",
          nested: true,
          subitems: [
            {
              title: "แบนเนอร์",
              icon: "mdi-wrench",
              to: "/index/Banner",
            },
            // {
            //   title: "เวลาปิด/เปิด",
            //   icon: "mdi-wrench",
            //   to: "/index/list-articles",
            // },
            {
              title: "คำถามก่อนเริ่มภารกิจ",
              icon: "mdi-wrench",
              to: "/index/quiz-manage",
            },
            {
              title: "รายชื่อโครงการ",
              icon: "mdi-wrench",
              to: "/index/list-project",
            },
            {
              title: "จัดการซีซั่น",
              icon: "mdi-wrench",
              to: "/index/insert-season",
            },
            {
              title: "บทความ",
              icon: "mdi-wrench",
              to: "/index/list-articles",
            },

            {
              title: "วีดีโอ",
              icon: "mdi-wrench",
              to: "/index/list-vdo",
            },
            {
              title: "จัดการภารกิจ",
              icon: "mdi-wrench",
              to: "/index/manageMission",
            },

          ],
        },

        { title: "ออกจากระบบ", icon: "mdi-logout" },
      ],

      version: "",
    };
  },
  created() {
    this.version = this.$version;
    this.$token_api.get("/jwt-detail").then((res) => {
      this.SET_USER(res.data.data[0]);
    });
  },
  methods: {
    ...mapMutations({
      SET_USER: "Drawer/SET_USER_DEAIL",
    }),
    checkMenu(item) {
      if (item.title == "ออกจากระบบ") {
        this.$swal({
          title: "ออกจากระบบ",
          text: `กรุณากดปุ่ม "ยีนยัน" เพื่อออกจากระบบ`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        }).then((result) => {
          if (result.value) {
            localStorage.clear();
            this.$router.push({ path: "/" });
          }
        });
      }
    },
  },
};
</script>